import theme from '@/style';
import {View} from 'react-native';
import {useInnerStyle} from '../invitation.style.hooks';
import LazyImage from '@/components/basic/image';
import {
  invitationImcomeIcon,
  invitationPeopleIcon,
} from '../invitation.variables';
import React from 'react';
import {useTranslation} from 'react-i18next';
import Text from '@/components/basic/text';
import {toPriceStr} from '@/utils';
import {RecordIcon, RulesIcon} from '../svg.variables';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import Button from '@/components/basic/button';
import {UserTotal} from '../invitation.type';
import {ReactComponent as ChavronRight} from '@/assets/icons/invitation/chavron-right.svg';
export interface InvitationInfoProps {
  onRule?: () => void;
  onRecord?: () => void;
  onAgency?: () => void;
  userTotal?: UserTotal;
  agent: boolean;
  completeCount: number;
}

const InvitationInfo: React.FC<InvitationInfoProps> = ({
  onRule,
  onRecord,
  onAgency,
  agent,
  completeCount,
  userTotal,
}) => {
  const {homeStyle} = useInnerStyle();
  const {t} = useTranslation();
  return (
    <div className="flex flex-col px-4 py-3 rounded-lg bg-[#2B1C05] z-[5] border border-[#D0BD88]">
      <View style={[theme.flex.col, theme.padding.btml, homeStyle.infoUpItem]}>
        <View style={[theme.flex.row]}>
          <View
            style={[theme.flex.flex1, theme.flex.col, theme.flex.alignStart]}>
            <View style={[theme.flex.row]}>
              <LazyImage
                imageUrl={invitationImcomeIcon}
                width={theme.iconSize.l}
                height={theme.iconSize.l}
                occupancy="#0000"
              />
              <Text color={'#C9B65B'} style={[theme.margin.lefts]}>
                {t('invitation.home.income')}
              </Text>
            </View>
            <div
              className="font-din font-bold text-2xl bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  'linear-gradient(to bottom, #F7C673 0%, #FFF7D9 50%, #F0BF32 100%)',
              }}>
              {toPriceStr(userTotal?.bonusAmountTotal || 0, {
                thousands: true,
                fixed: 0,
              })}
            </div>
          </View>
          <View
            style={[
              theme.flex.flex1,
              homeStyle.infoUpSubItemRight,
              theme.flex.col,
              theme.flex.alignEnd,
            ]}>
            <View style={[theme.flex.row]}>
              <LazyImage
                imageUrl={invitationPeopleIcon}
                width={theme.iconSize.l}
                height={theme.iconSize.l}
                occupancy="#0000"
              />
              <Text color={'#C9B65B'} style={[theme.margin.lefts]}>
                {t('invitation.home.count')}
              </Text>
            </View>
            <div
              className="font-din font-bold text-2xl bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  'linear-gradient(to bottom, #F7C673 0%, #FFF7D9 50%, #F0BF32 100%)',
              }}>
              {userTotal?.invitedNumberTotal || 0}
            </div>
          </View>
        </View>
        {!agent && completeCount >= 3 && (
          <View style={[theme.flex.col, theme.margin.topl]}>
            <Button radius={40} type="linear-primary" onPress={onAgency}>
              <View style={[theme.flex.col, theme.flex.center]}>
                <Text
                  color={theme.basicColor.white}
                  blod
                  fontSize={theme.fontSize.m}>
                  {t('invitation.home.join')}
                </Text>
                <Text
                  color={theme.basicColor.white}
                  fontSize={theme.fontSize.xs}>
                  {t('invitation.home.join-tip')}
                </Text>
              </View>
            </Button>
          </View>
        )}
      </View>

      <View style={[theme.flex.row, theme.flex.between, theme.margin.topxxl]}>
        <NativeTouchableOpacity
          style={[theme.flex.row, theme.flex.centerByCol]}
          onPress={onRecord}>
          <RecordIcon
            width={theme.iconSize.l}
            height={theme.iconSize.l}
            className="text-white/80"
          />
          <Text
            color={'rgba(255, 255, 255, 0.8)'}
            style={[theme.margin.lrs, homeStyle.infoBottomText]}>
            {t('invitation.home.record')}
          </Text>
          <ChavronRight className="text-white/80 size-3.5" />
        </NativeTouchableOpacity>
        <NativeTouchableOpacity
          style={[theme.flex.row, theme.flex.centerByCol]}
          onPress={onRule}>
          <RulesIcon
            width={theme.iconSize.l}
            height={theme.iconSize.l}
            className="text-white/80"
          />
          <Text
            color={'rgba(255, 255, 255, 0.8)'}
            style={[theme.margin.lrs, homeStyle.infoBottomText]}>
            {t('invitation.home.reward-rules')}
          </Text>
          <ChavronRight className="text-white/80 size-3.5" />
        </NativeTouchableOpacity>
      </View>
    </div>
  );
};

export default InvitationInfo;
